import axios from "axios";
import { ENDPOINTS } from "./endpoints";

const { LESSON_PLAN } = ENDPOINTS;

// Drop empty values so they are not sent as `?key=`
const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );

/**
 * Paginated lesson plans. Without `lesson_plan.view_all` the backend only
 * returns the logged-in teacher's plans.
 * @param {Object} params
 * @param {number} params.teacher_id
 * @param {number} params.program_id
 * @param {number} params.subject_id
 * @param {string} params.status - pending | completed
 * @param {string} params.lesson_date_from - yyyy-MM-dd
 * @param {string} params.lesson_date_to - yyyy-MM-dd
 * @param {string} params.search
 * @param {string} params.sort_by - e.g. lesson_date
 * @param {string} params.sort_order - asc | desc
 * @param {number} params.page
 * @param {number} params.per_page
 */
export const getLessonPlans = (params) =>
  axios.get(LESSON_PLAN.GET, { params: cleanParams(params) });

export const getLessonPlanById = (id) =>
  axios.get(`${LESSON_PLAN.GET_LESSON_PLAN}/${id}`);

export const createLessonPlan = (data) => axios.post(LESSON_PLAN.CREATE, data);

export const updateLessonPlan = (id, data) =>
  axios.put(`${LESSON_PLAN.UPDATE}/${id}`, data);

export const deleteLessonPlan = (id) =>
  axios.delete(`${LESSON_PLAN.DELETE}/${id}`);

/** Classes and subjects the teacher can create lesson plans for. */
export const getLessonPlanFormOptions = () => axios.get(LESSON_PLAN.FORM_OPTIONS);

/** Teacher / class / subject options for the All Lesson Plans filter. */
export const getLessonPlanFilterOptions = (params) =>
  axios.get(LESSON_PLAN.FILTER_OPTIONS, { params: cleanParams(params) });

/** @param {{ remarks: string }} data - teacher remarks, may be empty */
export const markLessonPlanComplete = (id, data = {}) =>
  axios.put(`${LESSON_PLAN.UPDATE}/${id}/${LESSON_PLAN.COMPLETE}`, data);

/** @param {{ reason: string, remarks: ?string, revised_delivery_date: ?string }} data - date as yyyy-MM-dd */
export const flagLessonPlan = (id, data) =>
  axios.put(`${LESSON_PLAN.UPDATE}/${id}/${LESSON_PLAN.FLAG}`, data);
